module.exports = __webpack_public_path__ + "static/media/Harry-Potter-Logo.c0d48dc1.png";